export default __webpack_public_path__ + "static/media/pay-order.00192314.svg";